import { Grid } from '@mui/material';
import { SettingsEditorPanelContainer } from './settings-editor-panel/settings-editor-panel.container';
import { SettingsTreePanelContainer } from './settings-tree-panel/settings-tree-panel.container';
import { useSettingsTreePanelStyles } from './settings-tree-panel/settings-tree-panel.styles';

export function SettingsPanels() {
  const classes = useSettingsTreePanelStyles();

  return (
    <Grid container className={classes.grid} spacing={2}>
      <Grid
        size={{
          xs: 5,
          lg: 4,
          xl: 3
        }}
      >
        <SettingsTreePanelContainer />
      </Grid>
      <Grid
        size={{
          xs: 7,
          lg: 8,
          xl: 9
        }}
      >
        <SettingsEditorPanelContainer />
      </Grid>
    </Grid>
  );
}
